import { render, staticRenderFns } from "./ISeatMultiPicker.vue?vue&type=template&id=45dff960&"
import script from "./ISeatMultiPicker.vue?vue&type=script&lang=js&"
export * from "./ISeatMultiPicker.vue?vue&type=script&lang=js&"
import style0 from "./ISeatMultiPicker.vue?vue&type=style&index=0&id=45dff960&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports